import { Service, inject } from '@angular/core'
import {
  GetManagedPlacesResponse,
  ManagedPlace,
  CreatePlaceBody,
  EditPlaceBody,
  SetPlaceStatusBody,
  DeleteEntityResponse,
} from '@seiri/shared/common'
import { ApiService } from '../api.service'

@Service()
export class ManagePlaceApiService {
  private readonly api = inject(ApiService)

  getManagedPlaces(entityId: string, init?: RequestInit) {
    return this.api.protectedFetchJson<GetManagedPlacesResponse>(`manage/entities/${entityId}/places`, { ...init })
  }

  getManagedPlace(entityId: string, placeId: string, init?: RequestInit) {
    return this.api.protectedFetchJson<ManagedPlace>(`manage/entities/${entityId}/places/${placeId}`, { ...init })
  }

  createPlace(entityId: string, body: CreatePlaceBody, init?: RequestInit) {
    return this.api.protectedFetchJson<ManagedPlace>(`manage/entities/${entityId}/places`, {
      method: 'POST',
      body: JSON.stringify(body),
      ...init,
    })
  }

  editPlace(entityId: string, placeId: string, body: EditPlaceBody, init?: RequestInit) {
    return this.api.protectedFetchJson<ManagedPlace>(`manage/entities/${entityId}/places/${placeId}`, {
      method: 'PATCH',
      body: JSON.stringify(body),
      ...init,
    })
  }

  deletePlace(entityId: string, placeId: string, init?: RequestInit) {
    return this.api.protectedFetchJson<DeleteEntityResponse>(`manage/entities/${entityId}/places/${placeId}`, {
      method: 'DELETE',
      ...init,
    })
  }

  setPlaceStatus(entityId: string, placeId: string, body: SetPlaceStatusBody, init?: RequestInit) {
    return this.api.protectedFetchJson<ManagedPlace>(`manage/entities/${entityId}/places/${placeId}/status`, {
      method: 'PUT',
      body: JSON.stringify(body),
      ...init,
    })
  }
}
